window.modalHandler = {
  modalOpen(modal) {
    document
      .querySelectorAll('[data-modal]')
      .forEach(mEl => modalHandler.modalClose(mEl))
    modal.classList.add('modal_show');
    document.body.classList.add('overflow');
    modal.dispatchEvent(new Event('open'));
    document.querySelector('html').classList.add('disable-scroll');
  },
  modalClose(modal) {
    modal.classList.remove('modal_show');
    document.body.classList.remove('overflow');
    document.querySelector('html').classList.remove('disable-scroll');
  }
}

document.addEventListener('DOMContentLoaded', function () {

  document
    .querySelectorAll('[data-modal]')
    .forEach(modal => {
      const btnClose = modal.querySelector('.modal__close');

      if (btnClose) {
        btnClose.addEventListener('click', function () {
          modalHandler.modalClose(modal);
        });
      }
    })

  document
    .querySelectorAll('[data-modal-open]')
    .forEach((btnOpenModal) => {
      btnOpenModal.addEventListener('click', function (e) {
        e.preventDefault();
        const id = btnOpenModal.getAttribute('data-modal-open');
        const modal = document.querySelector(`[data-modal="${id}"]`);
        if (btnOpenModal.hasAttribute('data-theme')) {
          modal.defaultTheme = btnOpenModal.getAttribute('data-theme');
        }
        modalHandler.modalOpen(modal);
      });
    })

  jQuery(window).on('dialog:beforecreate', e => {
    document
      .querySelectorAll('.ui-dialog .ui-dialog-buttonpane [data-drupal-messages]')
      .forEach(el => el.remove())
  })

  const inputsSelect = document.querySelectorAll('.modify-input__input-select');

  if (inputsSelect.length) {

    inputsSelect.forEach(select => {
      const inputItemText = select.querySelector('input[type="text"]');
      const inputItemFinish = select.querySelector('input[type="hidden"]');
      const listItems = select.querySelectorAll('li');

      inputItemText.addEventListener('click', ()=> {
        select.classList.toggle('_active');
      })

      document.addEventListener('click', e=> {
        if(!e.target.closest('.modify-input__input-select')) {
          select.classList.remove('_active');
        }
      })

      listItems.forEach(listItem=> {
        listItem.addEventListener('click', ()=> {
          select.classList.remove('_active');
          inputItemText.setAttribute('value', listItem.getAttribute('data-display'));
          inputItemFinish.setAttribute('value', listItem.getAttribute('data-value'));
        })
      })
    })
  }
});
